import React from 'react';
import Colors from "../../../../../utils/Colors";

const MessageReaction = ({ emoji, count, hasOwn, readonly, onClick }) => {
    return (
        <div
            className={`reaction ${hasOwn ? "has-own" : ""} ${readonly ? "readonly" : ""}`}
            data-emoji={emoji}
            onClick={()=>{
                !readonly && onClick && onClick();
            }}
        >
            <span className="emoji">{emoji}</span>
            <span>{count}</span>
        </div>
    );
};

export default MessageReaction;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/MessageReaction.jsx